var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.1@core-js/library/modules/_has.js
// module id = 55
// module chunks = 0